<template>
    <div dir="rtl">
        <!-- <div style="margin-top: 200px;" v-if="pathLogo == 'https://tpbspace.fra1.digitaloceanspaces.com/Demo/hr/CompanyLogo/'"></div> -->

        <!-- <div class="mlogo">
            <img class="wlogo" :src="pathLogo" />
        </div> -->

        <!-- <div style="width: 50;" dir="ltr" class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div> -->

        <h3 style="font-size: 30px;margin-top: 50px;" class="text-center">{{ alldata.fullName }}</h3>
        <h3 style="font-size: 20px;" class="text-center">{{ alldata.shortName }}</h3>
        <h3 class="text-center">كشف الحضور والإنصراف التفصيلي
        </h3>

        <div>
            <h3 style="font-size: 20px; " class="text-center"> من <span style="margin-left;: 10px">{{ convert(date)
                    }}</span> الى<span style="margin-right: 10px">{{ convert(DateTo) }}</span></h3>
        </div>

        <div style="margin: 0px 30px; padding-top: 20px">
            <div style="margin-top: 10px; margin-bottom: 35px;border: 0.5px solid rgb(67, 160, 71); " class="marginTop">

                <md-card-header style="margin-bottom: 30px;" class="md-card-header-text md-card-header-green">
                    <div class="card-text">
                        <h4 class="title">الحضور والإنصراف التفصيلي</h4>
                    </div>
                </md-card-header>

                <md-card-content>

                    <md-table :value="items" :md-sort.sync="currentSort" :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort" class="
                      paginated-table
                      custome-paginated-table
                      table-striped table-hover
                      mt-25
                      font-size-style
                    ">
                        <md-table-row class="font-size-style-row" slot="md-table-row" slot-scope="{ item }">


                            <md-table-cell class="w-200" md-label="الموظف">
                                <p>
                                    {{ item.employeeName }}
                                </p>
                            </md-table-cell>

                            <md-table-cell class="w-160" md-label="رقم الموظف">
                                <p>
                                    {{ item.jobNumber }}
                                </p>
                            </md-table-cell>

                            <!-- <md-table-cell class="w-160" md-label="الوضع الحالي">
                                <p>
                                    {{  item.currentSituation == 4 ? 'متفرغ' : '' }}
                                </p>
                            </md-table-cell> -->

                            <md-table-cell class="w-160" md-label="مجموع الغياب">
                                <p>
                                    {{ item.totalAbsents }}
                                </p>
                            </md-table-cell>

                            <md-table-cell class="w-100" v-for="(detail, id) in item.details" :key="id"
                                :md-label="day_n(detail.date) + '-' + convertDayString(detail.dayString)">
                                <div v-if="detail.dayType == 3">إجازة</div>
                                <div v-else-if="detail.currentSituation == 4">متفرغ</div>
                                <div v-else-if="detail.currentSituation == 6">تدريب</div>
                                <div v-else-if="detail.currentSituation == 4">مكلف</div>
                                <div v-else-if="detail.currentSituation == 2">منتدب</div>
                                <div v-else-if="detail.dayTypeString == 'عطلة'">عطلة</div>
                                <div v-else-if="detail.excuseType == '5'">
                                    <p>{{ detail.attendanceTime == null ? "-" : convertTime(detail.attendanceTime) }}
                                    </p>
                                    <p>عذر</p>

                                </div>
                                <div v-else-if="detail.excuseType == '3'">غائب بعذر</div>
                                <div v-else>
                                    <p>{{ detail.attendanceTime == null ? "-" : convertTime(detail.attendanceTime) }}
                                    </p>
                                    <p>{{ detail.leaveTime == null ? "-" : convertTime(detail.leaveTime) }}</p>
                                </div>
                            </md-table-cell>



                            <md-table-cell></md-table-cell>

                        </md-table-row>
                    </md-table>

                </md-card-content>
            </div>

        </div>



    </div>
</template>

<script>
import env from "../../../env";

import { time } from 'console';


export default {
    mounted() {
    },
    props: ["items", "alldata", "date", "pathLogo", "DateTo"],
    data() {
        return {
            currentSort: "",
            currentSortOrder: "asc",
            red: "#ecbbbb",
            blue: "#adc8f5",
            green: "#7ecf81",
            m: env.mTop(),

        };
    },
    methods: {


        day_n(event) {

            let d = new Date(event);
            let fullDay = d.getDate()

            return (

                fullDay
            );

        },


        convertDayString(event) {
            let day;
            switch (event) {

                case "الخميس":
                    day = "خ";
                    break;
                case "الجمعة":
                    day = "ج";
                    break;
                case "السبت":
                    day = "س";
                    break;
                case "الأحد":
                    day = "ح";
                    break;
                case "الاثنين":
                    day = "ن";
                    break;
                case "الثلاثاء":
                    day = "ث";
                    break;
                case "الأربعاء":
                    day = "ع";
            }

            return day;

        },

        day2(event, id) {

            try {

                let d = new Date(event);
                let fullDay = new Date((d.getMonth() + 1) + "/" + (id + 1) + "/" + d.getFullYear())
                // alert(fullDay)
                // var days = [' - Sun', ' - Mon', ' - Tue', ' - Wed', ' - Thu', ' - Fri', ' - Sat'];
                var days = [' - ح', ' - ن', ' - ث', ' - ع', ' - خ', ' - ج', ' - س'];
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (

                    days[fullDay.getDay()]


                );
            } catch (error) { }
        },

        convert(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (
                    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },

        convertTime(event) {
            try {

                var time = event;
                var resultArray = time.split(":");

                return (

                    time.replace(":" + resultArray[2], "")
                );
            } catch (error) { }
        },
        convertToUi(event) {
            try {
                let d = new Date(event);
                if (isNaN(d.getFullYear()) === true) {
                    return "-";
                }
                return (
                    (d.getMonth() + 1) + "-" + d.getFullYear()

                    // +
                    // " , "
                    // +
                    // d.getHours() +
                    // ":" +
                    // d.getMinutes()
                );
            } catch (error) { }
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === "desc") {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/Timesheet";

.col_color {
    margin-top: 60px;
    direction: rtl;
    color: black;
    background-color: rgb(236, 187, 187);
    padding: 0px 10px 0px 10px;
    margin-left: 10px;
}
</style>